import { useCallback } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'

import ClickableListItem from 'LuxKit/List/ClickableListItem'
import Caption from 'LuxKit/Typography/Caption'
import type { TripListRowType } from './tripListTypes'
import TripListTypeIcon from './TripListTypeIcon'
import TripListCheckboxButton from './TripListCheckboxButton'

const StartIconWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${rem(12)};
`

interface Props {
  type: TripListRowType
  label: string
  count: number
  selected: boolean
  onToggle: (type: TripListRowType) => void
}

function TypeFilterMenuItem({ type, label, count, selected, onToggle }: Props) {
  const handleClick = useCallback(() => {
    onToggle(type)
  }, [onToggle, type])

  return (
    <ClickableListItem
      title={label}
      size="medium"
      onClick={handleClick}
      startIcon={(
        <StartIconWrapper>
          <TripListCheckboxButton size="small" checked={selected} readOnly />
          <TripListTypeIcon type={type} />
        </StartIconWrapper>
      )}
    >
      <Caption variant="large" colour="light-foreground-alt">
        {count}
      </Caption>
    </ClickableListItem>
  )
}

export default TypeFilterMenuItem
